const INTERNAL_API_MESSAGE_PATTERNS: RegExp[] = [
  /^The route .+ could not be found\.?$/i,
  /^No query results for model/i,
  /SQLSTATE/i,
];

export function isInternalApiErrorMessage(message: string): boolean {
  const normalized = message.trim();

  if (!normalized) {
    return true;
  }

  return INTERNAL_API_MESSAGE_PATTERNS.some((pattern) => pattern.test(normalized));
}

export function sanitizeApiErrorBody(body: unknown): unknown {
  if (!body || typeof body !== 'object') {
    return body;
  }

  const record = body as Record<string, unknown>;
  const message = record['message'];

  if (typeof message === 'string' && isInternalApiErrorMessage(message)) {
    const { message: _removed, ...rest } = record;
    return rest;
  }

  return body;
}
